import {useEffect, useState} from "react";

import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {usePropertyReservationState} from "../../reservation/hooks/use_property_reservation_state";
import {UNLOCK_CHOICE_AVAILABILITY_WAIT_MS} from "../constants/unlock_choice_timeouts";

// The availability of the free reservation behind the same gate as the reservation button of the page, awaited for a limited time only
export const useUnlockChoiceReservationAvailability = (property: IPropertyDetail | null, canOfferReservation: boolean) => {
    const {ctaState} = usePropertyReservationState(canOfferReservation ? property : null, "unlock_choice");
    const [isWaitOver, setIsWaitOver] = useState(false);

    // Counted from the start, not from the loaded property, so that waiting for the availability never runs into the decision timeout of the choice
    useEffect(() => {
        if (!canOfferReservation) {
            return;
        }

        const timeoutId = setTimeout(() => setIsWaitOver(true), UNLOCK_CHOICE_AVAILABILITY_WAIT_MS);

        return () => clearTimeout(timeoutId);
    }, [canOfferReservation]);

    return {
        isLoading: ctaState === "pending" && !isWaitOver,
        // An availability that did not arrive in time, or whose latest check failed, counts as unavailable - the meeting is offered instead
        isAvailable: ctaState === "active"
    };
};
import {useEffect, useState} from "react";

import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {usePropertyReservationState} from "../../reservation/hooks/use_property_reservation_state";
import {UNLOCK_CHOICE_AVAILABILITY_WAIT_MS} from "../constants/unlock_choice_timeouts";

// The availability of the free reservation behind the same gate as the reservation button of the page, awaited for a limited time only
export const useUnlockChoiceReservationAvailability = (property: IPropertyDetail | null, canOfferReservation: boolean) => {
    const {ctaState} = usePropertyReservationState(canOfferReservation ? property : null, "unlock_choice");
    const [isWaitOver, setIsWaitOver] = useState(false);

    // Counted from the start, not from the loaded property, so that waiting for the availability never runs into the decision timeout of the choice
    useEffect(() => {
        if (!canOfferReservation) {
            return;
        }

        const timeoutId = setTimeout(() => setIsWaitOver(true), UNLOCK_CHOICE_AVAILABILITY_WAIT_MS);

        return () => clearTimeout(timeoutId);
    }, [canOfferReservation]);

    return {
        isLoading: ctaState === "pending" && !isWaitOver,
        // An availability that did not arrive in time, or whose latest check failed, counts as unavailable - the meeting is offered instead
        isAvailable: ctaState === "active"
    };
};
